// extracted by mini-css-extract-plugin
module.exports = {"home":"LeaveTypes_home__1Sxhh","actionButton":"LeaveTypes_actionButton__1FvST","error":"LeaveTypes_error__1wN1-"};